export const EGE_TUTORS = {
  'matematika-profil': {
    subject: 'math',
    image: '/v2/ege/tutors/math.webp',
    skills: [
      'Окончил МГУ им. М.В. Ломоносова, кафедру физики твердого тела физического факультета',
      // eslint-disable-next-line max-len,vue/max-len
      'Участник научной конференции «Ломоносов», призер конкурса дипломных работ «Ломоносов», выпускник программы высшей школы бизнеса МГУ «doing business»',
      'Средний результат учеников: <br>86 баллов по ЕГЭ и 4,5 балла по ОГЭ',
    ],
  },
  matematika: {
    subject: 'math',
    image: '/v2/ege/tutors/math.webp',
    skills: [
      'Окончил МГУ им. М.В. Ломоносова, кафедру физики твердого тела физического факультета',
      // eslint-disable-next-line max-len,vue/max-len
      'Участник научной конференции «Ломоносов», призер конкурса дипломных работ «Ломоносов», выпускник программы высшей школы бизнеса МГУ «doing business»',
      'Средний результат учеников: <br>86 баллов по ЕГЭ и 4,5 балла по ОГЭ',
    ],
  },
  'russkij-yazyk': {
    subject: 'russian',
    image: '/v2/ege/tutors/russian2.webp',
    skills: [
      'Окончила бакалавриат и магистратуру СПбГУ по направлению «Отечественная филология»',
      'Преподаватель старших классов в частной школе в Санкт-Петербурге, лектор на научно-популярных площадках',
      'За месяц занятий может в два раза увеличить балл ученика',
      'Средний результат учеников: <br>91 балл по ЕГЭ и 4,7 балла по ОГЭ',
    ],
  },
  literatura: {
    subject: 'literature',
    image: '/v2/ege/tutors/literature.webp',
    skills: [
      'Магистрант филологического факультета МПГУ',
      // eslint-disable-next-line max-len,vue/max-len
      'Кредо: «Преподаю комфортно — с мемами про русскую классику, учетом возрастных особенностей и профессионализмом».',
      'Автор Telegram-канала о русских писателях и поэтах «В контексте» (20 000 подписчиков)',
      'Средний результат учеников: <br>91 балл по ЕГЭ и 5 баллов по ОГЭ',
    ],
  },
  'anglijskij-yazyk': {
    subject: 'english',
    image: '/v2/ege/tutors/english2.webp',
    skills: [
      // eslint-disable-next-line max-len,vue/max-len
      'Окончила бакалавриат на лингвиста-переводчика (английский и немецкий языки) и магистратуру на преподавателя иностранных языков',
      'Университет Лейфана в г. Люнебург (2014) и Гете — Институт (2017), Германия',
      'Международный экзамен IELTS на английском языке: Listening 8,5 Reading 9 Writing 6,5 Speaking 8 = 8 из 9',
      'Средний результат учеников: <br>80 баллов по ЕГЭ и 4,3 балла по ОГЭ',
    ],
  },
  fizika: {
    subject: 'physics',
    image: '/v2/ege/tutors/physics.webp',
    skills: [
      'Окончил НИТУ МИСиС, ИНМиН, «Электроника и наноэлектроника»',
      'Преподает физику в Лицее НИУ ВШЭ',
      'Магистрант РГГУ «Культурология ХХ—ХХI». Занимается исследованиями науки и техники',
      'Средний результат учеников: <br>83 балла по ЕГЭ и 5 баллов по ОГЭ',
    ],
  },
  himiya: {
    subject: 'chemistry',
    image: '/v2/ege/tutors/chemistry.webp',
    skills: [
      'Окончила РХТУ имени Д.И.Менделеева',
      // eslint-disable-next-line max-len,vue/max-len
      'Научный сотрудник в химической лаборатории. Автор научных статей, в том числе в иностранных журналах',
      'Участвовала более чем в 20 научных конференциях в России и за рубежом',
      'Средний результат учеников: <br>90 баллов по ЕГЭ и 4,8 балла по ОГЭ',
    ],
  },
  biologiya: {
    subject: 'biology',
    image: '/v2/ege/tutors/biology.webp',
    skills: [
      'Получил высшее медицинское образование по направлению: "Лечебное дело"',
      'Сдал ЕГЭ по биологии на 100 баллов',
      'Является экспертом по проверке экзаменационных работ ЕГЭ по биологии и химии',
      'Средний результат учеников: <br>85 баллов по ЕГЭ и 4,9 балла по ОГЭ',
    ],
  },
  informatika: {
    subject: 'informatics',
    image: '/v2/ege/tutors/informatics.webp',
    skills: [
      // eslint-disable-next-line max-len,vue/max-len
      'Окончил МГУ им. М.В. Ломоносова по специальности «геология», бакалавр; получил диплом магистра в РГУНиГ им. И.И. Губкина, факультет геологии и геофизики нефти и газа',
      'Курировал проекты JuniorSkills/WorldSkills в сфере аэрокосмических технологий',
      'Средний результат учеников: <br>86 баллов по ЕГЭ и 4,4 балла по ОГЭ',
    ],
  },
  istoriya: {
    subject: 'history',
    image: '/v2/ege/tutors/history2.webp',
    skills: [
      'Аспирант кафедры права НИУ ВШЭ',
      'Объясняет сложную историю простым языком',
      '10% учеников - московские и федеральные медалисты',
      'Средний результат учеников: <br>85 баллов по ЕГЭ и 5 баллов по ОГЭ',
    ],
  },
  obshchestvoznanie: {
    subject: 'social',
    image: '/v2/ege/tutors/social.webp',
    skills: [
      'Выпускник Лицея НИУ ВШЭ по социально-экономическому профилю, студент 5 курса ОП «Юриспруденция» НИУ ВШЭ',
      // eslint-disable-next-line max-len,vue/max-len
      'Призер олимпиад «Высшая проба» и РАНХиГС по обществознанию и политологии, призер регионального этапа ВсОШ по обществознанию',
      'Выпускники учатся в МГУ, ВШЭ, МГИМО и других топовых вузах',
      'Средний результат учеников: <br>80 баллов по ЕГЭ и 4,3 балла по ОГЭ',
    ],
  },
};

export const OGE_TUTORS = {
  matematika: {
    subject: 'math',
    image: '/v2/ege/tutors/math2.webp',
    skills: [
      'Окончил СГСПУ ',
      'Учитель математики высшей квалификационной категории',
      'Победитель II степени регионального конкурса «Молодой учитель» Самарской области 2019',
      'Лауреата регионального конкурса «Учитель года Самарской области – 2022» в номинации «Открываю мир детям»',
      'Средний результат учеников: <br>83 балла по ЕГЭ и 4,5 балла по ОГЭ',
    ],
  },
  'russkij-yazyk': {
    subject: 'russian',
    image: '/v2/ege/tutors/russian2.webp',
    skills: [
      'Окончила бакалавриат и магистратуру СПбГУ по направлению «Отечественная филология»',
      'Преподаватель старших классов в частной школе в Санкт-Петербурге, лектор на научно-популярных площадках',
      'За месяц занятий может в два раза увеличить балл ученика',
      'Средний результат учеников: <br>91 балл по ЕГЭ и 4,7 балла по ОГЭ',
    ],
  },
  literatura: {
    subject: 'literature',
    image: '/v2/ege/tutors/literature2.webp',
    skills: [
      // eslint-disable-next-line max-len,vue/max-len
      'Окончила ЛГПУ им.П.П.Семёнова-Тян-Шанского, бакалавриат — «Педагогическое образование» и магистратура — «Современное лингвистическое образование»',
      'Учитель литературы в школе с 7-летним стажем',
      // eslint-disable-next-line max-len,vue/max-len
      'Является спикером фестивалей и марафонов для учителей, проводит мастер-классы и читает лекции по литературе и современному искусству',
      'Средний результат учеников: <br>90 баллов по ЕГЭ и 4,6 балла по ОГЭ',
    ],
  },
  'anglijskij-yazyk': {
    subject: 'english',
    image: '/v2/ege/tutors/english2.webp',
    skills: [
      // eslint-disable-next-line max-len,vue/max-len
      'Окончила бакалавриат на лингвиста-переводчика (английский и немецкий языки) и магистратуру на преподавателя иностранных языков',
      'Университет Лейфана в г. Люнебург (2014) и Гете — Институт (2017), Германия',
      'Международный экзамен IELTS на английском языке: Listening 8,5 Reading 9 Writing 6,5 Speaking 8 = 8 из 9',
      'Средний результат учеников: <br>80 баллов по ЕГЭ и 4,3 балла по ОГЭ',
    ],
  },
  fizika: {
    subject: 'physics',
    image: '/v2/ege/tutors/physics.webp',
    skills: [
      'Окончил НИТУ МИСиС, ИНМиН, «Электроника и наноэлектроника»',
      'Преподает физику в Лицее НИУ ВШЭ',
      'Магистрант РГГУ «Культурология ХХ—ХХI». Занимается исследованиями науки и техники',
      'Средний результат учеников: <br>83 балла по ЕГЭ и 5 баллов по ОГЭ',
    ],
  },
  himiya: {
    subject: 'chemistry',
    image: '/v2/ege/tutors/chemistry.webp',
    skills: [
      'Окончила РХТУ имени Д.И.Менделеева',
      // eslint-disable-next-line max-len,vue/max-len
      'Научный сотрудник в химической лаборатории. Автор научных статей, в том числе в иностранных журналах',
      'Участвовала более чем в 20 научных конференциях в России и за рубежом',
      'Средний результат учеников: <br>90 баллов по ЕГЭ и 4,8 балла по ОГЭ',
    ],
  },
  biologiya: {
    subject: 'biology',
    image: '/v2/ege/tutors/biology2.webp',
    skills: [
      'Окончила МГМУ им. Сеченова',
      'Сдала ЕГЭ по биологии на 93 балла',
      // eslint-disable-next-line max-len,vue/max-len
      'С учениками на одной волне: “шутим и смеемся, чтобы лучше запомнить материал, использую красочные авторские материалы, онлайн-тесты, викторины”',
      'Средний результат учеников: <br>86 баллов по ЕГЭ и 4,8 балла по ОГЭ',
    ],
  },
  informatika: {
    subject: 'informatics',
    image: '/v2/ege/tutors/informatics.webp',
    skills: [
      // eslint-disable-next-line max-len,vue/max-len
      'Окончил МГУ им. М.В. Ломоносова по специальности «геология», бакалавр; получил диплом магистра в РГУНиГ им. И.И. Губкина, факультет геологии и геофизики нефти и газа',
      'Курировал проекты JuniorSkills/WorldSkills в сфере аэрокосмических технологий',
      'Средний результат учеников: <br>86 баллов по ЕГЭ и 4,4 балла по ОГЭ',
    ],
  },
  istoriya: {
    subject: 'history',
    image: '/v2/ege/tutors/history2.webp',
    skills: [
      'Аспирант кафедры права НИУ ВШЭ',
      'Объясняет сложную историю простым языком',
      '10% учеников - московские и федеральные медалисты',
      'Средний результат учеников: <br>85 баллов по ЕГЭ и 5 баллов по ОГЭ',
    ],
  },
  obshchestvoznanie: {
    subject: 'social',
    image: '/v2/ege/tutors/social.webp',
    skills: [
      'Выпускник Лицея НИУ ВШЭ по социально-экономическому профилю, студент 5 курса ОП «Юриспруденция» НИУ ВШЭ',
      // eslint-disable-next-line max-len,vue/max-len
      'Призер олимпиад «Высшая проба» и РАНХиГС по обществознанию и политологии, призер регионального этапа ВсОШ по обществознанию',
      'Выпускники учатся в МГУ, ВШЭ, МГИМО и других топовых вузах',
      'Средний результат учеников: <br>80 баллов по ЕГЭ и 4,3 балла по ОГЭ',
    ],
  },
};
